/**
 * Persist a locally-constructed UserMediaEntity in secure storage so the
 * owner's UserDetailsPage can re-display the processing item and re-attach
 * the Firestore live listener on subsequent mounts.
 *
 * Key shape: `PendingProcessingMedia_<mediaId>` — per-media key supports
 * multiple concurrent uploads.
 */

import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { PendingProcessingMediaStorage } from '@/domain/entities/secureStorage/pendingProcessingMediaStorage';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

export class SavePendingProcessingMediaUseCase {
  constructor(private storage = SecureStorageWebCrypto.getInstance()) {}

  async execute(media: UserMediaEntity): Promise<void> {
    const key = SECURE_STORAGE_KEYS.PENDING_PROCESSING_MEDIA + media.id;
    const value: PendingProcessingMediaStorage = { name: media.id, media };
    await this.storage.setEncrypted(key, value);
  }
}

export const savePendingProcessingMediaUseCase = new SavePendingProcessingMediaUseCase();
